import forge from "node-forge";

export const jsonToQueryParams = json => {
  return Object.entries(json)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");
};

// decrypt data
export const decrypt = async data => {
  let { encryptedData, salt, iv } = data;
  // Convert encoded values back to binary
  const key = forge.pkcs5.pbkdf2(
    process.env.REACT_APP_ENCRYPTION_KEY,
    forge.util.decode64(salt),
    10000,
    32,
  );
  const decipher = forge.cipher.createDecipher("AES-CBC", key);
  decipher.start({ iv: forge.util.decode64(iv) });
  decipher.update(forge.util.createBuffer(forge.util.decode64(encryptedData)));
  const success = decipher.finish(); // Returns true if successful

  if (success) {
    const decrypted = decipher.output.toString();
    return JSON.parse(decrypted);
  } else {
    console.log("Error");
  }
};

// Example Usage

// let data = {
//   "encryptedData": "8YEb4LYDcnDuuCgQ0X7R9+7s563P66XIBU5s3D/d7JnjyS9aGtJWdcKsCKy/TjBjCY/vt6Tfa6gMjWRz13vpzonu6efoBzwILgdvSmIpQUgWEyyvUR6M7f3THCX1S3ePO5m6LrgQHonxpH8wgJPdDJcEBRxRUjLpHjeXXmcU2OLLl0VNKF9RtPrWY6kW0hOrQbzlBeODY3CAVTGTh038JwBbBnY7btxp4rGz6poqvlQt1NEcOCWK11aPL9XRLlrdeZdzrzf63jGSL9oBxK4mh7OKgC0bhEaeA+Fg5E8xFWAbEtG+u+MYkwbXvuIoCw7AWEbPa/3q+9LZHqrBjoB19eIBLvOOQEh8lIy1rZdRyr0YMgXrD/nC4hZ3EJ2g95yGoc/s/4DeHvLn+WrUV/PlVRcMYk2IZDz/pmSrgBL4Mhhs/276NNJFIpe59rKggZ88",
//   "salt": "xekLa6FY5w69c38TKDuvnw==",
//   "iv": "EdgThACrml0nn7xxlFwHhA=="
// }
//
// await decrypt(data)
// console.log(await decrypt(data))
